<span
  [ngStyle]="{ backgroundColor: LETTER_COLORS[letter.toLowerCase()] }"
  class="avatar"
>
  <p>{{ letter }}</p>
</span>
